// Commerce Endpoints
// Old wcs endpoints
export const EQUIPMENT_SEARCH_REST =
  '/store/{0}/equipmentSearch?searchTerm={1}&catalogId={2}&langId={3}&storeId={0}&filter={4}';
export const PENDING_ORDER_DETAILS =
  '/AjaxLogonForm?orderId={0}&storeId={1}&langId={2}&catalogId={3}&route=PendingOrderDetails';
export const PENDING_QUOTE_DETAILS =
  '/AjaxLogonForm?orderId={0}&storeId={1}&langId={2}&catalogId={3}&route=PendingQuoteDetails';
export const DEALER_SEARCH = '/store/{storeId}/dealer-customer';
export const DEALER_CUSTOMER_LOCATIONS = `/eCommerce/dealerLocations/v2/locations/summary`;
export const COMMERCIAL_OFFERS =
  '/store/{storeId}/equipment/commercialOffer/{offerId}?locale={locale}';
export const JOBS_DESCRIPTION_URL =
  '/store/{0}/selfServiceOptions/bySelfServiceOptionId?langId={1}&ssId={2}&serialNumber={3}&model={4}&serialNoBegin={5}&serialNoEnd={6}&unit={7}&isPM={8}&isCATKit={9}&hash={10}';
export const DROPBOX_DATA =
  '/store/{0}/dealer-customer/@self/fulfillment/dropbox?langId={1}';
export const PRE_SELECT_STORE = '/dealercustomerOrgSetInSesion';
export const GET_RCC_PAGE =
  '/wcs/resources/store/{storeId}/xperson/registerurl?new=Y&myAcctMain=1&espot=true&consent=true&isRegistration=true&storeId={store}&langId={langId}&stlocId={locationId}&country={countryCode}&dealerName={dealerName}&dealerCode={dealerCode}&envHost={envHost}';
export const USER_RESET_IN_SESSION = '/userResetInSession';
export const CAT_VANTAGE_ENROLLMENT =
  '/store/{storeId}/catVantage/enrollmentStatus';
//This endpoint refer to Existing Legacy Dealer Price and Avaialbility
export const DEALER_PRICE_AVAILABILITY =
  '/store/{storeId}/getDealerPriceAndAvailability?langId={langId}';

// New headless api endpoints
export const SUBMIT_EDIT_ADDRESS =
  '/eCommerce/me/addresses/{id}?storeId={storeId}';
export const SUBMIT_CONTACTUS_FORM = '/eCommerce/customerService/v1/contactUs';
export const GET_COUNTRIES_STATES = '/eCommerce/geographic/v1/countries';
export const RETURN_DETAILS = '/eCommerce/orderManagement/v2/returns/{orderId}';
export const SUBMIT_ADP =
  '/eCommerce/me/v2/entitlements?storeId={storeId}&locale={locale}';
export const DEALER_INFO = '/eCommerce/dealerManagement/v2/dealers';
export const DEALER_ASSOCIATION = '/eCommerce/me/dealerAssociations';
export const DEALER_CUSTOMERS_DCN =
  '/eCommerce/dealerUser/v1/customers/{customerNumber}';
export const DEALER_CUSTOMERS =
  '/eCommerce/me/dealerCustomers/{customerNumber}';
export const DEALER_CUSTOMERS_BY_DCN =
  '/eCommerce/dealer-user/v1/customersByDCN';
export const ESITE_INFO = '/eCommerce/esites';
export const ESPOT_INFO = '/eCommerce/marketing/v1/contents';
export const SUPPORTED_LANGUAGES = '/eCommerce/languages';
export const EQUIPMENT_URL = '/eCommerce/me/equipment';
export const CART_URL = '/eCommerce/shoppingCart/v2/orders';
export const LOCATIONS = '/eCommerce/locations';
export const LOCATIONS_STORES = '/eCommerce/locations/dealerStores';
export const GUEST_IDENTITY = '/eCommerce/auth/guestIdentity';
export const LOCATION_INFO = '/eCommerce/{0}/{1}';
export const USER_INFO = '/eCommerce/me/v2/userDetails';
export const COUNTRY_PHONE =
  '/store/{storeId}/locations/getCustCareTelephonyInfo';
export const ORDER_CONFIRMATION_PICKUP_DELIVERY =
  '/eCommerce/orderManagement/v2/orders/{orderId}/fulfillment';
export const PRICE_AVAILABILITY =
  '/eCommerce/dealerManagement/v2/products/priceAndAvailability/search';
export const SOURCE_OF_SUPPLY_HEADLESS =
  '/eCommerce/dealers/products/sourceOfSupply/search';
export const PRICE_AVAILABILITY_HEADLESS =
  '/eCommerce/dealers/products/priceAndAvailability/search';
export const CART_SHARE_LINK = '/eCommerce/shoppingCart/v2/orders/deepLinkCart';
export const CART_PRICE_AVAILABILITY =
  '/eCommerce/shoppingCart/v2/orderItems/priceAndAvailability';
export const SUBMIT_REQUEST_SERVICE =
  '/eCommerce/equipmentCatalog/v2/serviceRequests/submit';
export const SEARCH_REQUEST_SERVICE =
  '/eCommerce/equipmentCatalog/v2/serviceRequests/searchLatest';
export const ORDER_CHECKOUT =
  '/eCommerce/shoppingCart/v2/orders/checkout?storeId={storeId}&locale={locale}&orderId={orderId}';
export const EMAIL_CART_TO_DEALER =
  '/eCommerce/shoppingCart/v2/orders/emailCartToDealer?storeId={storeId}&locale={locale}';
export const ORDER_ITEM = '/eCommerce/shoppingCart/v2/orderItems';
export const ORDER_ITEM_UPDATE = '/eCommerce/shoppingCart/v2/orderItems';
export const EMPTY_CART_ITEMS = '/eCommerce/shoppingCart/orderItems';
export const ORDER_ATTRIBUTES =
  '/eCommerce/shoppingCart/v2/orders/orderAttributes';
export const SAVE_LINE_ITEMS = '/eCommerce/shoppingCart/orderItemAttributes';
export const VALIDATE_CART_ITEMS =
  '/eCommerce/shoppingCart/v2/orderItems/validation';
export const ORDER_ITEM_DELETE =
  '/eCommerce/shoppingCart/orderItems/{orderItemId}';
export const CART_ORDER_TOTALS =
  '/eCommerce/shoppingCart/orderDetails/{orderId}/orderTotals';
export const CART_ORDER_DETAILS = '/eCommerce/shoppingCart/orderDetails';
export const ORDER_PAYMENT =
  '/eCommerce/orderManagement/v2/orders/{orderId}/payment';
export const TRANSLATION_URL =
  '/eCommerce/translations?storeId={storeId}&locale={locale}';
export const B2C_TOKEN = '/eCommerce/me/v2/accessToken';
export const AVAILABILITY_BY_SOURCE =
  '/eCommerce/dealerManagement/v2/products/sourceOfSupply/search?';
export const ORDER_DETAILS = '/eCommerce/orderManagement/v2/orders/{orderId}';
export const SAVED_LISTS =
  '/eCommerce/shoppingListManagement/v1/shoppingLists/summary'; //Need to remove this.
export const CREATE_SAVED_LISTS =
  '/eCommerce/shoppingListManagement/v1/shoppingLists';
export const CORE_TRACKING = '/eCommerce/dealerCustomers/v2/coreTracking';
export const SAVED_LIST_DUPLICATE =
  '/eCommerce/shoppingListManagement/v1/shoppingLists/{shoppingListId}/copy';
export const SAVED_LIST_ACTION =
  '/eCommerce/shoppingListManagement/v1/shoppingLists/{shoppingListId}';
export const ADD_PART_TO_SAVED_LIST =
  '/eCommerce/shoppingListManagement/v1/shoppingLists/{shoppingListId}/orderItems';
export const UPDATE_PART_SAVED_LIST =
  '/eCommerce/shoppingListManagement/v1/shoppingLists/{shoppingListId}/orderItems/{orderItemId}';
export const BULK_DELETE_SAVED_LIST =
  '/eCommerce/shoppingListManagement/v1/shoppingLists/{shoppingListId}/orderItems/bulkDelete';
export const UPDATE_MULTIPLE_PARTS_SAVED_LIST =
  '/eCommerce/shoppingListManagement/v1/shoppingLists/{shoppingListId}/orderItems';
export const ORDERS_TO_APPROVE_LISTS =
  '/eCommerce/orderManagement/v2/approvals';
export const PENDING_QUOTES_LISTS = '/eCommerce/quoteOrders/v1/quotes';
export const PENDING_QUOTES_EDIT = '/eCommerce/quoteOrders/v1/quotes/{orderId}';
export const PENDING_QUOTES_PLACE_ORDER =
  '/eCommerce/quoteOrders/v1/quotes/{orderId}/activate';
export const PENDING_QUOTES_DELETE =
  '/eCommerce/quoteOrders/v1/quotes/{orderId}';
export const PENDING_QUOTES_DETAILS = '/eCommerce/orderInfo/orders/{orderId}';
export const RECENT_ORDERS_LIST = '/eCommerce/me/orders';
export const SHOPPING_LIST =
  '/eCommerce/shoppingListManagement/v1/shoppingLists/summary';
export const ORDER_SHIPMENT_DETAILS =
  '/eCommerce/orderManagement/v2/orders/{orderId}/shipmentInfo';
export const NOTIFICATIONS =
  '/eCommerce/me/v2/notifications?locale={locale}&storeId={storeId}';
export const GET_ADDRESS = '/eCommerce/me/addresses?storeId={storeId}';
export const DELETE_ADDRESS = '/eCommerce/me/addresses/{id}';
export const ADDRESS_VALIDATION = '/eCommerce/addressValidation/validate';
export const ORDERS_LIST = '/eCommerce/orderManagement/v2/orders';
export const EXPORT_ORDER =
  '/eCommerce/orderManagement/v2/orders/{orderId}/export';
// LSI Endpoints
export const FITMENT_CHECK_URL = '/eCommerce/products/v2/compatibility';
export const PRODUCT_DETAIL = '/eCommerce/products/v2/{productId}';
export const PRODUCT_LIST = '/eCommerce/products/v2/byCategory/{urlKeyword}';
export const SUMMARY_URL = '/eCommerce/products/v2/itemSummary';
export const FBT_ITEMS_URL = '/eCommerce/products/frequentlyBoughtTogether';
export const LOAD_ESPOTS = '/eCommerce/marketing/v1/contents';
export const PRODUCTS_SEARCH_URL = '/eCommerce/productSearch/v1/products';
export const PRODUCTS_SEARCH_URL_V3 = '/eCommerce/productSearch/v3/products';
export const PRODUCTS_SEARCH_URL_V4 = '/eCommerce/productSearch/v4/products';
export const PRODUCTS_SEARCH_CATEGORIES_PRODUCTS =
  '/eCommerce/productSearch/v3/attachments/products';
export const PRODUCTS_SEARCH_EQUIPMENT_FAMILY =
  '/eCommerce/productSearch/v3/attachments/equipmentFamilies';
export const SEARCH_SUGGESTION_URL = '/eCommerce/productSearch/v2/suggestions';
export const CATEGORIES = '/eCommerce/categories/v2/partsCategories';
export const USER_PREFERENCES = '/eCommerce/me/v2/preferences';
export const USER_PREFERENCES_V3 = '/eCommerce/me/v3/preferences';
export const JOBS_RECOMMENDATIONS_URL =
  '/eCommerce/products/v2/jobRecommendations';
export const BESTSELLERS_URL = '/eCommerce/products/v2/bestSellers';
export const BUY_AGAIN_URL = '/eCommerce/products/v2/products/purchaseHistory';
export const PAYMENT_METHODS_URL =
  '/eCommerce/me/paymentMethods/supportedAndBillingAddresses?storeId={storeId}&orderId={orderId}&locale={locale}';
export const STORED_PAYMENTS_URL =
  '/eCommerce/me/paymentMethods?storeId={storeId}';
export const SAVE_PAYMENT_INFORMATION_URL =
  '/eCommerce/me/paymentMethods?storeId={storeId}&orderId={orderId}';
export const CSR_AUDIT_SUMMARY_URL =
  '/eCommerce/me/v2/csrAuditSummary?storeId={storeId}';
export const DELETE_PAYMENT_METHOD_URL =
  '/eCommerce/me/paymentMethods?id={id}&removeTokenFromPaymentProvider={removeTokenFromPaymentProvider}&storeId={storeId}';

export const MACHINE_SEARCH = '/eCommerce/equipmentCatalog/v2/equipment';
export const MACHINE_DETAILS = '/eCommerce/equipment/v2/machineDetails';

//Order confirmation endpoint
export const ORDER_APPROVAL_DETAILS =
  '/eCommerce/orderManagement/v2/orders/{orderId}/approvals?storeId={storeId}&locale={locale}';
export const SEND_EMAIL_ORDER_CONFIRMATION =
  '/eCommerce/dealerUser/v1/dealerNotifications/orderConfirmationEmail?storeId={storeId}&locale={locale}';
export const DROPBOX_ORDER_INFO =
  '/eCommerce/me/dealerCustomers/dropBoxes?locale={locale}&storeId={storeId}';

// OMM Endpoints
export const OMM_CATALOG_URL = '/catalogs';
export const OMM_CONTENT_URL = '/contents';

// ECT Endpoints
export const ECT_MESSAGE_API_URL =
  '/dealers/{dealerCode}/messages?messageCode={messageCode}';

export const ECT_SHIPPING_METHODS_API_URL =
  '/dealers/{dealerCode}/shippingMethods';

// ECT OUTAGE Endpoints
export const ECT_OUTAGE_API_URL =
  '/dealers/{dealerCode}/messages/erpOutageMessage?locale={locale}';

// Espot Endpoints
export const ESPOT_MARKETING_API_URL =
  '/wcs/resources/store/{storeId}/marketingData?langId={langId}&espotName={espotName}';

export const DELETE_LINE_ITEM_BUNDLES =
  '/wcs/resources/store/{storeId}/xorder/@self/delete-bundles';

export const PENDING_QUOTES_STOP_EDIT_URL_LEGACY =
  '/wcs/resources/store/{0}/xorder/stop-edit-quote?id={1}&langId={2}';

//Email link
export const CONTACT_US_DEALER =
  '/CATContactUsDisplayView?catalogId={0}&langId={1}&storeId={2}';
export const APPROVE_REJECT_ORDER =
  '/eCommerce/orderManagement/v2/approvals/{orderId}';

// My Equipment
export const MEQ_ADD_EQUIPMENT = '/eCommerce/equipmentList/v2/items';
export const MEQ_SELECT_EQUIPMENT =
  '/eCommerce/equipmentList/v2/items/{id}/select';
export const MEQ_DELETE_EQUIPMENT = '/eCommerce/equipmentList/v2/items/{id}';
export const MEQ_EDIT_EQUIPMENT = '/eCommerce/equipmentList/items';
export const MEQ_DESELECT_EQUIPMENT = '/eCommerce/equipmentList/items/deselect';
export const EQUIPMENT_SEARCH_URL = '/eCommerce/equipment';
export const EDIT_EQUIPMENT_SERIAL_PREFIX_SUGGESTIONS =
  '/eCommerce/equipment/v2/machineDetails?locale={locale}&storeIdentifier={storeIdentifier}&salesModel={salesModel}';
export const GET_UCID_LIST = '/store/{storeId}/dealer-customer/ucid/search';
export const SAVED_LIST_SHARE_UCID_LIST = '/eCommerce/dealerUser/v1/sharedList';
export const GET_DCN_LIST = '/eCommerce/dealerUser/v1/dealerCustomers/search';

// MNT Endpoints
export const SYSTEMS_AND_COMPONENT =
  '/eCommerce/productSearch/v2/partsInformation/systemComponents';
export const MAINTANCE_AND_REPAIR = '/eCommerce/productSearch/v2/kits/summary';
export const LIST_OF_ARRANGEMENTS =
  '/eCommerce/productSearch/v2/partsInformation/configurationList';
export const PART_DETAILS_SCHEMATIC =
  '/eCommerce/productSearch/v2/partsInformation/partDetails';
export const PART_WHERE_USED =
  '/eCommerce/productSearch/v2/partsInformation/groupPartDetails';
export const PRODUCT_DIAGRAM_LIST =
  '/eCommerce/productSearch/v2/partsInformation/diagrams?partNumber={partNumber}&serialNumber={serialNumber}&locale={locale}';
export const PRODUCT_DIAGRAM =
  '/eCommerce/productSearch/v2/partsInformation/imageProcess?graphicControlNumber={graphicControlNumber}&format={format}';
// External endpoints
// Places Suggestions Locations
export const PLACES_SUGGESTIONS_URL =
  'https://dev.virtualearth.net/REST/v1/Autosuggest';

export const GET_FORM_API =
  'api-stage.cat.com/marketing/ecrm/formPublishing/v2/forms/F-2026:FV-000008?locale={locale}';
export const GET_FORM_API_PROD =
  'api.cat.com/marketing/ecrm/formPublishing/v2/forms/{formId}?locale={locale}';
export const SEARCH_BEFORE_ASK_API =
  'services.cat.com/catDigital/consents/v1/marketingConsents/search';
export const SEARCH_BEFORE_ASK_API_PROD =
  'api.cat.com/catDigital/consents/v1/marketingConsents/search';
export const HIMS_API =
  'ecrm-contact-identifier-qa.herokuapp.com/data/contact-management/v2/contact/identifier/match';
export const HIMS_API_PROD =
  'api.cat.com/marketing/ecrm/data/contact-management/v2/contactidentifier/match';
// Service Recommendation Endpoints
export const SR_SUBTOTAL = '/eCommerce/productSearch/subtotal';

export const COMMERCIAL_OFFERS_SEARCH =
  '/store/{storeId}/equipment/offers/search?locale={locale}';

export const SR_UPDATE_USER_STATE = '/instances/{id}';
//Header Navigation Menu
export const HEADER_NAVIGATION_MENU =
  '/store/{0}/header/navigationMenu?langId={1}&subCategoryLimit={2}';
//Support options phone numbers
export const SUPPORT_PHONE_NUMBERS =
  '/eCommerce/geographic/v1/customerSupportPhoneNumbers';

export const FOOTER_LINK_HELP_CENTER = `{0}/help/faq`;

export const INSTANCE_SEARCH =
  '/store/{storeId}/equipment/instances/search?locale={locale}';

export const SOURCE_OF_SUPPLY = '/store/{storeId}/dealer/sourceOfSupply';
export const PRICE_AVAILABILITY_LEGACY =
  '/store/{storeId}/dealer/priceAndAvailability';

export const EQUIPMENT_INSTANCE_PATCH_UPDATE =
  '/eCommerce/equipment/v2/userState/{instanceId}';

export const SEARCH_SUGGESTION_URL_V1 =
  '/eCommerce/productSearch/v1/suggestions';
export const SEARCH_SUGGESTION_URL_V2 =
  '/eCommerce/productSearch/v2/suggestions';
export const MEQ_EDIT_EQUIPMENT_V2 = '/eCommerce/equipmentList/v2/items';

export const INSTANCE_SEARCH_HEADLESS =
  '/eCommerce/equipment/v2/instances?storeId={storeId}&locale={locale}';

export const SSO_REDIRECT_URL =
  '/store/{storeId}/dealer-association/ssoRedirect/@self';
export const APPLY_PROMO_CODE = '/eCommerce/shoppingCart/applyPromoCode';

export const REMOVE_PROMO_CODE = '/eCommerce/shoppingCart/removePromoCode';

export const FULFILLMENT = '/eCommerce/shoppingCart/v2/orders/fulfillment';

export const TAX_AND_FREIGHT =
  '/eCommerce/shoppingCart/v2/orders/fulfillment/taxAndFreight';

export const SSO_KIT_DETAILS_URL = '/eCommerce/productSearch/v2/kits/{id}';

//SIS to PCC Cart Import
export const DEEPLINK_URL =
  '/eCommerce/shoppingCart/v2/deepLinkCarts/{deepLinkCartId}?locale={locale}&storeId={storeId}';

export const GET_ATTACHMENT_SUGGESTION_URL =
  '/eCommerce/productSearch/v3/attachments/suggestions';

//Payment and summary endpoints
export const UPDATE_ORDER_ATTRIBUTES =
  '/eCommerce/orderManagement/v2/orders/{orderId}/orderAttributes';

export const INDUSTRY_META_DATA_URL =
  '/eCommerce/equipmentCatalog/v2/industryMetaData?serialNumber={serialNumber}';

export const SEND_EMAIL_SALESFORCE =
  '/eCommerce/orderManagement/v2/orders/{orderId}/salesForceOrderInfo';

//Invoices
export const INVOICES_LIST = '/eCommerce/orderManagement/v2/invoices';

export const POST_ATTACHMENT_PRODUCT_SUMMARY_URL =
  '/eCommerce/products/v2/products/summary';

export const CUSTOMER_VALUE_AGREEMENTS_URL =
  '/eCommerce/equipmentCatalog/v2/customerValueAgreements?dealerCode={dealerCode}&serialNumber={serialNumber}&locale={locale}';

export const UPLOAD_ATTACHMENT_FILES =
  '/eCommerce/shoppingCart/purchaseOrders?orderId={orderId}&storeId={storeId}&fileName={fileName}&locale=en_US&responseFormat=json';

export const DELETE_ATTACHMENT_FILES =
  '/eCommerce/shoppingCart/purchaseOrders/attachments?orderId={orderId}&storeId={storeId}';

// TODO: Pending verify the URL for get files
export const GET_ATTACHMENT_FILES =
  '/eCommerce/shoppingCart/purchaseOrders/attachments?orderId={orderId}&storeId={storeId}';
